module.exports = __webpack_public_path__ + "static/img/22hrFast.90642e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/22hrFast.png
// module id = wcQQ
// module chunks = 1